<template>
  <div
    class="trainer-rng trarng csst csst_nm"
    :class="{ trarng_hidden: !allVisible }"
    :style="`--anim-duration:${animDuration}ms`"
  >
    <div
      class="trarng_icon_cont"
      :class="{ trarng_icon_cont_roll: rollDice }"
    >
      <i
        class="mdi mdi-dice-6 trarng_icon"
        :class="[{ trarng_icon_roll: rollDice }, mode || '']"
      ></i>
    </div>
    <span
      class="trarng_value"
      :class="{ trarng_value_visible: numVisible }"
    >
      {{ l_rng }}
    </span>
    <div
      class="csst_content clr-white"
      style="position: fixed; margin-top: -3.5rem"
    >
      {{ mode ? $t(`btn.${mode}_rng`) : $t('common.rng') }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainerRng',
  props: {
    rng: [String, Number],
    mode: String, // high_rng low_rng
  },
  data() {
    return {
      animDuration: 220,
      rollDice: false,
      numVisible: false,
      allVisible: false,
      l_rng: '',
    }
  },
  methods: {
    setRng(num) {
      // console.log(num)
      this.numVisible = false
      this.allVisible = false
      if (num) {
        this.l_rng = num
        this.rollDice = true
        this.allVisible = true
        setTimeout(() => {
          this.rollDice = false
          this.numVisible = true
        }, this.animDuration)
      }
    },
  },
  watch: {
    rng: {
      immediate: true,
      handler: 'setRng',
    },
  },
}
</script>
<style lang="scss" scoped>
.trarng {
  // background: var(--clr-black-1);
  border-radius: 8px;
  // padding: 0.5rem 0;
  line-height: 1;
  flex: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--clr-grey-2);
  transition: 0.22s;
  &_hidden {
    opacity: 0;
  }
  &_icon {
    position: relative;
    font-size: 1.25rem;
    --anim-duration: 220ms;
    &.high {
      color: var(--clr-yellow);
    }
    &.low {
      color: var(--clr-blue);
    }
    // color: var(--clr-grey-2);
    &_cont {
      position: relative;
      transition: transform var(--anim-duration);
      display: flex;
      &_roll {
        transform: scale(1.2);
      }
    }
    &_roll {
      transition: var(--anim-duration);
      transform: rotate(360deg);
    }
  }
  &_value {
    font-weight: 500;
    font-size: 0.875rem;
    padding-left: 0.25rem;
    position: relative;
    left: -2rem;
    opacity: 0;
    font-weight: 700;
    transition: 0.15s;
    &_visible {
      left: 0;
      opacity: 1;
    }
  }
}
</style>
